<template>
  <div>
    <table class="hints">
    <tr>
        <th colspan="2">Indizi</th>
    </tr>
      <tr v-for="p in playersHints" :key="`ph_${p.id}`">
        <td>
          <span>{{ p.name }}</span>
        </td>
        <td v-if="!showHints">
          <template v-if="!p.isThisPlayer || hintSent">
            <font-awesome-icon icon="hourglass" spin v-if="!p.hintSent" />
            <font-awesome-icon icon="check-circle" style="color: #67c23a" v-else />
          </template>
          <template v-else>
            <Keypress :key-code="13" event="keyup" @pressed="sendHint" />
            <el-input type="text" placeholder="indizio" v-model="hint" style="margin-top: 5px" autofocus ref="hintInput"></el-input>
            <el-button
              type="primary"
              :disabled="!hintValid"
              @click="sendHint"
              style="margin-top: 5px"
            >invia</el-button>
          </template>
        </td>
        <td v-if="showHints">{{ p.hint }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import Vue from "vue";
import Hints from "./Hints";
export default Hints;
</script>

<style scoped>
.hints {
  margin: 0 auto;
  margin-top: 5vh;
  margin-bottom: 20px;
  border-collapse: collapse;
}
.hints td {
  min-width: 15vw;
  padding: 5px;
  border: 1px dotted silver;
}
</style>

